import { Convertible, type POSIXTime } from '../index.exports';
import { BaseTxRedeemer } from '../../Entities/index.exports';

export type FundPolicyRedeemer = FundPolicyRedeemerMintID | FundPolicyRedeemerBurnID | FundPolicyRedeemerMintFT | FundPolicyRedeemerBurnFT;

export class FundPolicyRedeemerMintID extends BaseTxRedeemer {
    protected static _plutusDataIndex = 0;
    protected static _plutusDataIsSubType = true;
}

export class FundPolicyRedeemerBurnID extends BaseTxRedeemer {
    protected static _plutusDataIndex = 1;
    protected static _plutusDataIsSubType = true;
}

export class FundPolicyRedeemerMintFT extends BaseTxRedeemer {
    static _plutusDataIndex = 2;
    static _plutusDataIsSubType = true;
}

export class FundPolicyRedeemerBurnFT extends BaseTxRedeemer {
    static _plutusDataIndex = 3;
    static _plutusDataIsSubType = true;
}

export type FundValidatorRedeemer =
    | FundValidatorRedeemerDatumUpdate
    | FundValidatorRedeemerUpdateMinADA
    | FundValidatorRedeemerFundHoldingAdd
    | FundValidatorRedeemerFundHoldingDelete
    | FundValidatorRedeemerEmergency
    | FundValidatorRedeemerFinish
    | FundValidatorRedeemerDelete;

export class FundValidatorRedeemerDatumUpdate extends BaseTxRedeemer {
    protected static _plutusDataIndex = 0;
    protected static _plutusDataIsSubType = true;
}

export class FundValidatorRedeemerUpdateMinADA extends BaseTxRedeemer {
    protected static _plutusDataIndex = 1;
    protected static _plutusDataIsSubType = true;
}

export class FundValidatorRedeemerFundHoldingAdd extends BaseTxRedeemer {
    protected static _plutusDataIndex = 2;
    protected static _plutusDataIsSubType = true;
}

export class FundValidatorRedeemerFundHoldingDelete extends BaseTxRedeemer {
    protected static _plutusDataIndex = 3;
    protected static _plutusDataIsSubType = true;
}

export class FundValidatorRedeemerEmergency extends BaseTxRedeemer {
    protected static _plutusDataIndex = 4;
    protected static _plutusDataIsSubType = true;
}

export class FundValidatorRedeemerFinish extends BaseTxRedeemer {
    protected static _plutusDataIndex = 5;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true, type: BigInt })
    rfDate!: POSIXTime;
}

export class FundValidatorRedeemerDelete extends BaseTxRedeemer {
    protected static _plutusDataIndex = 6;
    protected static _plutusDataIsSubType = true;
}
